import { useState, useEffect, useRef } from 'react'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { useDebounce } from '@/utils/fetch'
import apiFetch from '@/services/apiService'
import SuggestionsPortal from '@/components/SuggestionsPortal'

export default ({objectField, originalData, label = "Notaire"}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(null)
  const inputRef = useRef(null)

  const fetchSuggestions = useDebounce(async (term) => {
    if (!term || term.length < 2) {
      setSuggestions([])
      return
    }
    
    setLoading(true)
    try {

      const response = await apiFetch()
        .url(`notaires/search`)
        .query({ term })
        .get()
      
      setSuggestions(response.data || [])
    } catch (error) {
      console.error('Erreur lors de la recherche des notaires :', error)
      setSuggestions([])
    } finally {
      setLoading(false)
    }
  }, 300)

  // Charger les détails du notaire sélectionné
  useEffect(() => {
    setSelected(originalData)
    setSearchTerm(originalData)
  }, [originalData])

  // Gérer le changement dans le champ de recherche
  const handleInputChange = (e) => {
    const value = e.target.value
    objectField.onChange(value)
    setSearchTerm(value)
    fetchSuggestions(value)
    setShowSuggestions(true)
    
    // Si le champ est vidé, réinitialiser le contact sélectionné
    if (!value) {
      objectField.onChange('')
      setSelected(null)
    }
  }

  // Sélectionner un notaire dans les suggestions
  const handleSelect = (object) => {
    objectField.onChange(object)
    setSearchTerm(object)
    setSelected(object)
    setShowSuggestions(false)
  }

  // Réinitialiser le champ
  const resetSelected = () => {
    objectField.onChange('')
    setSelected(null)
    setSearchTerm('')
  }
  
  return (
    <div className="relative suggestions-container">
      <label className="input w-full">
        <span className="label">{label}</span>
        <input
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => setShowSuggestions(true)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          placeholder="Rechercher un notaire..."
          className="w-full"
          ref={inputRef}
        />
        {loading && <span className="loading loading-spinner loading-sm text-base-content/70 absolute right-2 top-1/2 transform -translate-y-1/2"></span>}
        {!loading && selected && (
          <button
          type="button"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-base-content/70 rounded-full w-4 h-4 transition-colors duration-200 ease-in hover:bg-gray-200 focus:outline-none focus:bg-gray-300 dark:text-white dark:hover:bg-dark-500 dark:focus:bg-dark-450 hover:bg-gray-200"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              resetSelected()
            }}
          >
            <XMarkIcon/>
        </button>
        )}
      </label>
      
      <SuggestionsPortal
        show={showSuggestions && (suggestions.length > 0 || (searchTerm.length >= 2 && !loading))}
        anchorRef={inputRef}
      >
        {suggestions.length > 0 ? (
          <div className="bg-base-100 shadow-lg rounded-lg mt-1 border border-base-300 max-h-60 overflow-y-auto">
            {suggestions.map((item, index) => (
              <div 
                key={index}
                className="p-2 hover:bg-base-200 cursor-pointer"
                onClick={() => handleSelect(item)}
              >
                <div className="font-medium">{item}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-base-100 shadow-lg rounded-lg mt-1 border border-base-300 p-2 space-y-2">
            <p>Aucun notaire trouvé</p>
            <p className="text-sm">
              Vous pouvez en saisir un nouveau librement.
            </p>
          </div>
        )}
      </SuggestionsPortal>
    </div>
  )

}